import { useEffect } from 'react';

import { PageLayout } from '~components/page/PageLayout';
import { EditUsergroups } from '~extension/edit-usergroups/EditUsergroups';
import useLabels from '~hooks/useLabels';
import { useNavigateToDefault } from '~hooks/useNavigateToPage';
import usePermissions from '~hooks/usePermissions';

export default function EditUsergroupsPage() {
  const { hlEditUsergroups } = useLabels(['hlEditUsergroups']);
  const navigateToDefault = useNavigateToDefault();
  const { hasManageUsergroupsPermission } = usePermissions();

  // Trigger: Redirect NON-Editors | Only Editors are allowed on this page
  useEffect(() => {
    if (!hasManageUsergroupsPermission) {
      navigateToDefault();
    }
  }, [hasManageUsergroupsPermission, navigateToDefault]);

  return (
    <PageLayout title={hlEditUsergroups} className="page--edit-usergroups">
      <div className="u-padding-horizontal-xxl u-padding-bottom-xxl">
        <div className="c-view__header u-margin-bottom-md">
          <div className="o-grid o-grid--unpad o-grid--bottom">
            <div className="o-grid__cell o-grid__cell--width-10">
              <h2>{hlEditUsergroups}</h2>
            </div>
          </div>
        </div>
        <div className="c-view__content">
          <div className="relative">
            <EditUsergroups />
          </div>
        </div>
      </div>
    </PageLayout>
  );
}
